/**
 * FOLLOWER BOOST — network page behaviours
 *  - quick configurator: service → pack → variant price (from Liquid JSON) → link to the service
 *  - client-side search over the service cards + "no results" state
 *  - sort select → Shopify `sort_by` navigation
 */

function formatMoney(cents, fmt) {
  const amount = (cents / 100).toFixed(2);
  if (fmt.includes('{{amount_with_comma_separator}}')) return fmt.replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  if (fmt.includes('{{amount_no_decimals_with_comma_separator}}')) return fmt.replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)));
  if (fmt.includes('{{amount_no_decimals}}')) return fmt.replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
  return fmt.replace('{{amount}}', amount);
}

function setupQuick(root = document) {
  root.querySelectorAll('[data-fb-quick]:not([data-fb-ready])').forEach((box) => {
    box.dataset.fbReady = '1';
    let data;
    try {
      data = JSON.parse(box.querySelector('[data-fb-quick-data]').textContent);
    } catch {
      return;
    }
    const service = box.querySelector('[data-fb-quick-service]');
    const pack = box.querySelector('[data-fb-quick-pack]');
    const price = box.querySelector('[data-fb-quick-price]');
    const go = box.querySelector('[data-fb-quick-go]');

    const fillPacks = () => {
      const p = data.products.find((x) => x.handle === service.value);
      pack.innerHTML = '';
      if (!p) return;
      p.variants.forEach((v) => {
        const o = document.createElement('option');
        o.value = String(v.id);
        o.textContent = v.title;
        o.dataset.price = String(v.price);
        if (v.money) o.dataset.meta = v.money;
        o.disabled = !v.available;
        pack.appendChild(o);
      });
      update();
    };
    const update = () => {
      const p = data.products.find((x) => x.handle === service.value);
      const opt = pack.selectedOptions[0];
      if (!p || !opt) return;
      price.textContent = formatMoney(parseInt(opt.dataset.price, 10), data.money_format);
      go.href = `${p.url}?variant=${opt.value}`;
    };
    service.addEventListener('change', fillPacks);
    pack.addEventListener('change', update);
    fillPacks();
  });
}

function setupGrid(root = document) {
  root.querySelectorAll('[data-fb-grid]:not([data-fb-ready])').forEach((sec) => {
    sec.dataset.fbReady = '1';
    const search = sec.querySelector('[data-fb-search]');
    const list = sec.querySelector('[data-fb-list]');
    const none = sec.querySelector('[data-fb-none]');
    const sort = sec.querySelector('[data-fb-sort]');

    if (search && list) {
      const cards = [...list.querySelectorAll('.fb-service, .fb-svc')];
      search.addEventListener('input', () => {
        const q = search.value.trim().toLowerCase();
        let shown = 0;
        cards.forEach((c) => {
          const hit = !q || c.textContent.toLowerCase().includes(q);
          c.hidden = !hit;
          if (hit) {
            shown++;
            c.classList.add('is-in');
          }
        });
        if (none) none.hidden = shown > 0;
      });
    }
    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
  });
}

const boot = () => {
  setupQuick();
  setupGrid();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
document.addEventListener('shopify:section:load', (e) => {
  setupQuick(e.target);
  setupGrid(e.target);
});
